import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Auth } from "../../../commonPage";
import { Commons } from "../../../utilities";
import { actionCommon } from "../../../redux/actions";
import { useAlert } from "../../../contexts";

const ForgotPasswordPage = () => {
    const doctor_access = JSON.parse(localStorage.getItem("doctor_access"));
    const isDoctorLoggedIn = doctor_access?.token;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { showAlert } = useAlert();

    useEffect(() => {
        if (isDoctorLoggedIn) {
            navigate("/doctor/dashboard");
        }
    }, [isDoctorLoggedIn, navigate]);
    const forgotSubmit = (credentials) => {
        dispatch(
            actionCommon.forgotPassword(credentials, (error, response) => {
                if (error) {
                    if (error.status === 400) {
                        const validationErrors = error.data?.error?.ValidationErrors || [];
                        const errorMessages = validationErrors
                            .map(
                                (validationError, index) =>
                                    `${t("Error")} ${index + 1}: ${t("Field")} - ${validationError.Field
                                    }, ${t("Message")} - ${validationError.Message}`
                            )
                            .join("\n");

                        showAlert("danger", errorMessages, `${t("Error")} !`);
                    }
                } else {
                    if (response.status === 200) {
                        showAlert("success", `${t("forgotPasswordPage.success_message")}`, `${t("success")} !`);
                        navigate("/doctor/login");
                    }
                }
            })
        );
    };

    if (isDoctorLoggedIn) {
        return null;
    }

    return (
        <Auth.ForgotCommonPage
            userType={Commons.userType.doctor}
            closeNavigate="/doctor"
            forgotSubmit={forgotSubmit}
        />
    );
};

export default ForgotPasswordPage;